import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-38a8ef1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "components-navigation",
  id: "Navigation"
}
const _hoisted_2 = { class: "navigation" }
const _hoisted_3 = { class: "navigation__logo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Ecoblox"
}, null, -1))
const _hoisted_5 = { class: "navigation__menu" }
const _hoisted_6 = { class: "greeting" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, { to: { name: 'AppDashboardIndexVue' } }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(" Hello "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.getAuthenticationName), 1),
              _createTextVNode(" , welcome back! ")
            ]),
            _createElementVNode("a", {
              href: "#",
              class: "hamburger",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePopup && _ctx.togglePopup(...args)), ["prevent"]))
            }, _hoisted_10),
            _createElementVNode("div", {
              class: _normalizeClass(["popup", { opened: _ctx.isPopupOpened }])
            }, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: { name: 'AppDashboardIndexVue' } }, {
                    default: _withCtx(() => [
                      _createTextVNode("Dashboard")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: { name: 'AppAccountInformationIndexVue' } }, {
                    default: _withCtx(() => [
                      _createTextVNode("My Account")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
                  }, "Logout")
                ])
              ])
            ], 2)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}